import React, { useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';
import grey from '@material-ui/core/colors/grey';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(2),
  },
  fleet: {
    background: grey[200],
    border: `1px solid ${grey[400]}`,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
  },
  option: {
    background: grey[100],
    border: `1px solid ${grey[400]}`,
    borderBottom: 0,
  },
}));

export default React.memo(function NestedList({
  fleets,
  onChange,
  checkedFleets,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(checkedFleets);

  const handleToggle = ({ fleet, fleetOption }) => () => {
    delete fleet.fleetOption;
    const exist = checked.find((c) => c._id === fleetOption._id);
    if (exist) {
      const newChecked = checked.filter((c) => c._id !== fleetOption._id);
      setChecked(newChecked);
      onChange(newChecked);
    } else {
      const newChecked = [...checked, { ...fleetOption, fleet }];
      setChecked(newChecked);
      onChange(newChecked);
    }
  };

  const handleClick = (_id) => {
    if (_id === open) {
      setOpen(false);
      return;
    }
    setOpen(_id);
  };

  return (
    <List component="nav" className={classes.root}>
      {fleets.map((fleet) => (
        <Fragment key={fleet._id}>
          <ListItem
            button
            className={classes.fleet}
            onClick={() => handleClick(fleet._id)}
          >
            <ListItemText primary={fleet.title} />
            {open === fleet._id ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          {Object.entries(fleet.fleetOptions).length ? (
            <Fragment>
              {fleet.fleetOptions.map((o) => (
                <Collapse
                  in={open === fleet._id}
                  timeout="auto"
                  unmountOnExit
                  key={o._id}
                >
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      className={classes.nested}
                      dense
                      button
                      onClick={handleToggle({ fleet, fleetOption: o })}
                      className={classes.option}
                    >
                      <ListItemIcon>
                        <Checkbox
                          edge="start"
                          checked={
                            checked.find((c) => c._id === o._id) ? true : false
                          }
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText primary={o.title} />
                    </ListItem>
                  </List>
                </Collapse>
              ))}
            </Fragment>
          ) : null}
        </Fragment>
      ))}
    </List>
  );
});
